// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Bitter', 'Bitter Fallback'","fontStyle":"normal"},"className":"__className_4c860f","variable":"__variable_4c860f"};